<template>
	<div class="col-12 bg-white rounded-cus cus-box-shadow">
		<div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterReport">
			<div class="col-6 pl-0 mt-auto mb-auto">
				<div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
			</div>
		</div>
		<div id="filterReport" class="collapse">
			<div class="col-12 pb-3 pl-2 pr-2 d-flex flex-wrap">
				<div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 pr-md-3">
					<input class="form-control form-control-sm font-size-10 font-size-sm-9 rounded-cus box-blue" placeholder="Cari Produk" type="text" v-model="search">
					<span class="icon-search"><i class="fas fa-search"></i></span>
				</div>
				<div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 pr-md-3 pt-2 pt-md-0">
					<v-select label="text" :reduce="category => category.value" :options="category" class="font-size-10 font-size-sm-9 color-gray-2" placeholder="Semua Kategori" v-model="categorySelected">
					</v-select>
				</div>
				<div class="col-12 col-lg-4 pl-0 pr-0 pt-2 pt-lg-0">
					<div class="col-12 pl-0 pr-0 d-flex">
						<div class="col-6 pl-0 pr-2 pr-md-3">
							<button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus" @click="reset"><span class="font-size-9">Reset</span></button>
						</div>
						<div class="col-6 pl-0 pr-0 pl-md-0 pr-md-3">
							<button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus" @click="cari"><span class="font-size-9">Cari</span></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			search: '',
			categorySelected: ''
		}
	},
	props: {
		category: {
			type: Array
		},
	},
	methods:{
		cari(){
			this.$emit('cari', this.search, this.categorySelected)
		},
		reset(){
			this.search = '',
			this.categorySelected = ''
			this.$emit('cari', this.search, this.categorySelected)
		}
	}
};
</script>

<style scoped>
</style>